{
  "composer": {
    "placeholder": "Thêm bình luận… Gõ @ để nhắc đồng nghiệp",
    "submit": "Gửi"
  },
  "mention": {
    "noResults": "Không tìm thấy người phù hợp"
  },
  "attachments": {
    "attach": "Đính kèm tệp",
    "deleted": "Đã xóa tệp đính kèm",
    "deleteFailed": "Không thể xóa tệp đính kèm",
    "typeRejected": "Định dạng tệp không được hỗ trợ",
    "limitReached": "Chỉ được đính kèm tối đa {{count}} tệp",
    "uploadPartialFailed": "Đã gửi bình luận nhưng một số tệp tải lên thất bại"
  },
  "thread": {
    "empty": "Chưa có bình luận nào",
    "loadMore": "Xem thêm {{count}} bình luận",
    "deleted": "Bình luận đã bị xóa",
    "edit": "Sửa",
    "delete": "Xóa",
    "save": "Lưu",
    "cancel": "Hủy",
    "reply": "Trả lời",
    "replyingTo": "Đang trả lời {{name}}",
    "replyPlaceholder": "Viết trả lời… Gõ @ để nhắc đồng nghiệp",
    "replyToAuthor": "Trả lời {{name}}",
    "parentDeleted": "Bình luận gốc đã bị xóa"
  },
  "toasts": {
    "created": "Đã thêm bình luận",
    "updated": "Đã cập nhật bình luận",
    "deleted": "Đã xóa bình luận",
    "createFailed": "Không thể thêm bình luận",
    "updateFailed": "Không thể cập nhật bình luận",
    "deleteFailed": "Không thể xóa bình luận",
    "loadFailed": "Không thể tải bình luận"
  }
}
